import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import TextBox from 'components/controls/TextBox';
import CircularProgress from 'components/CircularProgress';
import { showMessage, handleHTTPError } from 'store/actions';
import { resetPassword } from 'apis';
import './index.scss';

class ResetPass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newPassword: '',
            confirmPassword: '',
            email: '',
            code: '',
            loading: false,
            validate: false,
        };
    }

    componentDidMount = () => {
        const email = QueryString.parse(this.props.location.search).email;
        if (!email) {
            this.props.showMessage({
                show: true,
                message: {
                    text: 'Invalid URL',
                    type: 'error',
                },
            });
            return this.props.history.push('/');
        }
        this.setState({ email });
    };

    resetPass = async () => {
        if (this.state.loading) return;
        this.setState({ validate: true });

        const { newPassword, confirmPassword, email, code } = this.state;
        if (!newPassword || !confirmPassword || !code) return;
        if (newPassword !== confirmPassword)
            return this.props.showMessage({
                show: true,
                message: { text: 'New password is not matched', type: 'warning' },
            });
        try {
            this.setState({ loading: true });
            const params = { password: newPassword, email, code };
            const { message } = await resetPassword(params);
            this.props.showMessage({
                show: true,
                message: { text: message, type: 'success' },
            });
            this.props.history.push('/login');
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <div className="resetpass-wrapper">
                <div className="content border shadow bg-white text-center">
                    <div className="logo">
                        <img src="/images/logo/logo_green.png" alt="" style={{ maxWidth: '250px' }} />
                    </div>
                    <h1 className="mt-3 mb-4 font-weight-bold">Reset Password</h1>
                    <TextBox
                        label="New Password"
                        id="newPassword"
                        name="newPassword"
                        type="password"
                        required
                        className="mb-3 text-left"
                        validate={this.state.validate}
                        value={this.state.newPassword}
                        placeholder="New Password"
                        onBlur={(e) => {}}
                        onChange={(newPassword, e) => {
                            this.setState({ newPassword });
                        }}
                        validationOption={{
                            showMsg: false,
                            check: true,
                            required: true,
                        }}
                    />
                    <TextBox
                        label="Confirm Password"
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        required
                        className="mb-3 text-left"
                        validate={this.state.validate}
                        value={this.state.confirmPassword}
                        placeholder="Confirm Password"
                        onBlur={(e) => {}}
                        onChange={(confirmPassword, e) => {
                            this.setState({ confirmPassword });
                        }}
                        validationOption={{
                            showMsg: false,
                            check: true,
                            required: true,
                        }}
                    />
                    <TextBox
                        label="Verification Code"
                        id="verificationCode"
                        name="verificationCode"
                        type="text"
                        required
                        className="mb-3 text-left"
                        validate={this.state.validate}
                        value={this.state.code}
                        placeholder="3456"
                        onBlur={(e) => {}}
                        onChange={(code, e) => {
                            this.setState({ code });
                        }}
                        validationOption={{
                            showMsg: false,
                            type: 'number',
                            numberType: 'int',
                            check: true,
                            required: true,
                        }}
                    />
                    <Button
                        color="primary"
                        className="btn btn-primary btn-lg mt-4"
                        style={{ width: '200px' }}
                        onClick={this.resetPass}
                    >
                        Reset Password
                    </Button>
                    {this.state.type !== 'set' && (
                        <p
                            className="text-primary linkbtn text-center mt-4"
                            onClick={() => {
                                this.props.history.push('/');
                            }}
                        >
                            Try login again
                        </p>
                    )}
                    {this.state.loading && (
                        <div className="loader-view">
                            <CircularProgress />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default connect(null, {
    showMessage,
    handleHTTPError,
})(ResetPass);
